import React, {memo, useMemo, useState} from 'react'
import {useStateValue} from "../../state-provider/StateProvider";


const containerBaseStyle: React.CSSProperties = {
  display: 'flex',
  width: '100%',
}

const HeaderTitleComponent: React.FC<{}> = ({ }) => {

  const [{
    titleStyle,
    header,
  }] = useStateValue()

  const styles = useMemo<React.CSSProperties>(() => {
    return {
      ...containerBaseStyle,
      ...titleStyle,
    }
  }, [titleStyle])

  if (!header?.title) return null
  const parts = header.title.split('|')

  return (
    <div style={styles}>
      {parts.length > 1 ? (
        <>
          <h2 className="title">{parts[0]}</h2>
          <h3 className="subtitle">{parts[1]}</h3>
        </>
      ) : (
        <h3 className="title">{parts[0]}</h3>
      )}
    </div>
  )
}

export const HeaderTitle = memo(HeaderTitleComponent)
